import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyB_6bzu1U5o75XFxAVGfymuhBaGKTJKOO8",
  authDomain: "myunivers-3399a.firebaseapp.com",
  projectId: "myunivers-3399a",
  storageBucket: "myunivers-3399a.firebasestorage.app",
  messagingSenderId: "595441455061",
  appId: "1:595441455061:web:6c2a65d7ea541b6113775c",
  measurementId: "G-2WX1ZDZM2D"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export default app;
